import { useGet, usePost } from "../common/fetchServices";
import { AUTH_BASE_URL, STIP_BASE_URL } from "../props";
import { notBlank } from "../util/ext";

export const useCountries = () => {
  const url = `${STIP_BASE_URL}/geography/countries`;
  return useGet(["countries"], url);
};

export const useStates = country => {
  const code = notBlank(country) ? country.code : "US";
  const url = `${STIP_BASE_URL}/geography/countries/${code}/subdivisions`;
  return useGet(["states", { country: code }], url);
};

export const useRegions = () => {
  const url = `${AUTH_BASE_URL}/regions`;
  return useGet(["regions"], url);
};

export const useRegionCreate = () => {
  return usePost(() => `${AUTH_BASE_URL}/regions`, {
    queriesToInvalidate: ["regions"],
  });
};
